<template>
    <nav id="navigation" class="navbar navbar-expand-lg bg-white navbar-light">

        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbars-interactive-link" aria-controls="navbars-interactive-link" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"/>
        </button>

        <div id="navbars-interactive-link" class="collapse navbar-collapse">
            <ul id="navbar-menu-left" class="navbar-menu navbar-nav mr-auto">
                <li class="nav-item" @click="toggleSidebar">
                    <a class="d-flex square-icon nav-link" href="#">
                        <font-awesome-icon icon="ellipsis-v"/>
                    </a>
                </li>
                <li class="nav-item ml-3">
                    <router-link class="nav-link no-bg text-white" to="/">
                        Interactive LINK
                    </router-link>
                </li>
            </ul>
            <ul id="navbar-menu-right" class="navbar-menu navbar-nav">
                <li class="nav-item dropdown">
                    <a id="dropdown-profile"
                       class="nav-link dropdown square-icon"
                       href="#"
                       data-toggle="dropdown"
                       aria-haspopup="true"
                       aria-expanded="false">
                        <v-gravatar id="gravatar"
                                    v-if="this.$store.state.rubyIdent.user"
                                    :size="32"
                                    :email="this.$store.state.rubyIdent.user.email"/>
                    </a>

                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-profile">
                        <form @submit.prevent="onLogout">
                            <button class="dropdown-item">
                                <font-awesome-icon class="mr-1" icon="sign-out-alt"/>
                                Logout
                            </button>
                        </form>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "NavbarComponent",
        methods: {
            onLogout() {
                this.$store.dispatch('rubyIdent/logoutUser');
            },
            toggleSidebar() {
               this.$store.state.sidebarOpen = !this.$store.state.sidebarOpen;
            }
        }
    }
</script>

<style lang="scss" scoped>
    nav#navigation {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 48px;
        padding: 0;
        z-index: 1;
        background: paleturquoise;
        background-position: left top;
        background-image: url('/navbar_bg.jpg');

        div#navbars-interactive-link {
            width: auto;
            background-color: rgba(0,0,0,.3);

            #gravatar {
                border-radius: 50%;
            }

            ul.navbar-menu {
                li {
                    a {
                        height: 48px;
                        display: flex;
                        min-width: 48px;
                        text-align: center;
                        justify-content: center;
                        align-items: center;
                        -webkit-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
                        -moz-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
                        -ms-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
                        -o-transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;
                        transition: background-color .467s cubic-bezier(.1, .9, .2, 1) 34ms;

                        &:not(.no-bg) {
                            background-color: rgba(255,255,255,.3);
                        }

                        &:not(.no-bg):hover {
                            background-color: rgba(255,255,255,.8);
                        }
                    }
                }

            }
        }
    }
</style>